var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PromoHome',{attrs:{"active-block-id":1}}),_vm._v(" "),_c('section',{staticClass:"fdp-register-section"},[_c('div',{staticClass:"container-register-main"},[_c('nuxt-child')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }